import React from 'react';
import GoogleAd from './GoogleAdsense';
import FluidAd from './FluidAd';

const AdsSection = ({ 
  showTitle = true, 
  title = "Publicidad", 
  layout = "grid", // "grid", "single", "vertical"
  ads = [],
  backgroundColor = '#f8f9fa',
  margin = '60px 0',
  padding = '20px'
}) => {
  // Configuraciones predefinidas de anuncios
  const defaultAds = {
    horizontal: {
      slot: "1495310928",
      googleAdId: "ca-pub-4817534541991617",
      width: "100%",
      height: 250,
      float: "none",
      format: "horizontal"
    },
    rectangle: {
      slot: "1495310928",
      googleAdId: "ca-pub-4817534541991617",
      width: 336,
      height: 280,
      float: "none",
      format: "rectangle"
    },
    fluid: {
      type: "fluid"
    }
  };

  // Si no se proporcionan anuncios, usar configuración por defecto
  const adsToRender = ads.length > 0 ? ads : [
    defaultAds.horizontal,
    defaultAds.rectangle,
    defaultAds.fluid
  ];

  // Estilos según el layout
  const getLayoutStyles = () => {
    switch (layout) {
      case "single":
        return {
          display: 'flex',
          justifyContent: 'center',
          maxWidth: '600px',
          margin: '0 auto'
        };
      case "vertical":
        return {
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          maxWidth: '600px',
          margin: '0 auto'
        };
      case "grid":
      default:
        return {
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
          maxWidth: '1200px',
          margin: '0 auto'
        };
    }
  };

  const renderAd = (ad, index) => {
    if (ad.type === "fluid") {
      return <FluidAd key={`fluid-${index}`} />;
    }
    
    return (
      <GoogleAd 
        key={`google-ad-${index}`}
        slot={ad.slot}
        googleAdId={ad.googleAdId}
        width={ad.width}
        height={ad.height}
        float={ad.float}
        format={ad.format}
      />
    );
  };

  return (
    <div style={{ 
      margin, 
      padding, 
      backgroundColor,
      textAlign: 'center'
    }}>
      {showTitle && (
        <h3 style={{ 
          marginBottom: '30px', 
          color: '#333',
          fontSize: '1.8em',
          fontWeight: 'bold'
        }}>
          {title}
        </h3>
      )}
      
      <div style={getLayoutStyles()}>
        {adsToRender.map((ad, index) => renderAd(ad, index))}
      </div>
    </div>
  );
};

export default AdsSection;